import { grey } from '@mui/material/colors';
import * as React from 'react';
import { withStyles } from 'tss-react/mui';

const nakedStyles = (Component: React.FC<any>) =>
  withStyles(Component, (theme) => ({
    root: {
      '& .MuiInputBase-input': {
        color: theme.palette.text.secondary,
        backgroundColor: grey['100'],
        borderRadius: theme.shape.borderRadius,
      },
      '& .MuiInputBase-adornedEnd': {
        backgroundColor: grey['100'],
        paddingRight: 0,
      },
      '& .MuiInputBase-adornedStart': {
        backgroundColor: grey['100'],
      },
      '& .MuiInput-underline:before': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
      '& .Mui-error': {
        '& fieldset': {
          borderWidth: 1,
        },
      },
    },
  }));

export const NakedInputContainer = <T = React.FC<any>>(Box: T) => {
  const naked = nakedStyles(Box as React.FC<any>);
  return naked as T;
};

const NakedInput = <T = React.FC<any>>(Field: T) => {
  const naked = nakedStyles(Field as React.FC<any>);
  return naked as T;
};

export default NakedInput;
